export const ProgramHomepageText = {
  OurPrograms: {
    en: "Our Programs",
    mr: "आमचे कार्यक्रम",
  },
  AcceptTAndC: {
    en: "Ok",
    mr: "पुढे जा",
  },
};
